import React, { useState, useEffect, useRef } from "react";
import AuthNavComponent from "../module/auth/AuthNav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollarSign, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { InterestedJobs } from "./component/Sidebar/InterestedJobs";
import { Link, useParams } from "react-router-dom";
import Footer from "../module/Footer";
import { FormattedMessage, useIntl } from "react-intl";
import { getJobs } from "sr/utils/api/cleaner/jobs/getJobs";
import { JobPostedAge } from "sr/helpers/functions/JobPostedAge";
import { DateFormat } from "sr/helpers/functions/DateFormat";
import { HTMLStringRender } from "sr/helpers/ui-components/HTMLStringRender";
import { getAdditionInfo } from "sr/utils/api/company/getAdditionInfo";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import ContentWithLoader from "sr/layout/common/ContentLoader";
import { StringLoader } from "../component/Loader/StringLoader";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { createFavoriteJob } from "sr/utils/api/cleaner/createFavoriteJob";
import { useAuth } from "../module/auth";
import { getSavedJobs } from "sr/utils/api/cleaner/getSavedJobs";
import { useNavigate } from "react-router-dom";
import { ModelWrapperWithButton } from "../company/component/ModelWrapperWithButton";
import { createApplication } from "sr/utils/api/cleaner/createApplication";
import { getFiles } from "sr/utils/api/getFiles";
import { uploadFile } from "sr/utils/api/uploadFile";
import { Checkbox } from "sr/helpers";
import { SocialShare } from "../component/SocialShare";
import { Helmet } from "react-helmet";
import { ModelWrapper } from "../company/component/ModelWrapper";
import CheckBoxHandle from "sr/helpers/functions/CheckBoxHandle";
import { addReportJob } from "sr/utils/api/cleaner/addReportJob";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";
import { getJobTypeCategory } from "sr/utils/api/getJobTypeCategory";
import { validateFile } from "sr/helpers/functions/validateFile";
import { getContractor } from "sr/utils/api/company/workorder/getContractor";
import { toast } from "react-toastify";
import {
  benifitdata,
  employment,
  Schedule,
  supplementalpaydata,
} from "../company/jobpost/component/Jsonalldata";
import { payTypes } from "sr/i18n/messages/setting";
import { formatNumberWithCommas } from "sr/helpers/functions/formatNumber";
import { getGeneralType } from "sr/utils/api/getGeneralType";
import { TrainingCertificationRequirementWarning } from "sr/helpers/ui-components/company/TrainingCertificationRequirementWarning";
import { getTraining } from "sr/utils/api/cleaner/getTraining";
import { createTraning } from "sr/utils/api/cleaner/createTraning";
import { ConfirmModal } from "app/pages/component/ConfirmModal";
import { RequiredTrainingCertificationModal } from "./component/RequiredTrainingCertificationModal";
import { getEmployment } from "sr/utils/api/cleaner/getEmployment";
import { getReference } from "sr/utils/api/cleaner/getReference";
export default function JobDetails() {
  const intl = useIntl();
  const { isAuthenticate, userType } = useAuth();
  const [job, setJob] = useState(null);
  const [companyName, setcompanyName] = useState();
  const { id } = useParams();
  const [postedDays, setpostedDays] = useState(null);
  const [companyAdditional, setCompanyAdditional] = useState(null);
  const [loader, setLoader] = useState("");
  const [cleanerId, setCleanerId] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isApplied, setIsApplied] = useState(false);
  const [message, setMessage] = useState("");
  const [applyWithOld, setapplyWithOld] = useState(false);
  const [reportJobPopup, setReportJobPopup] = useState(false);
  const [reportjob, setReportJob] = useState([]);
  const [fileerror, setFileError] = useState(null);
  const [resumes, setResumes] = useState(null);
  const [showRequirementPrompt, setShowRequirementPrompt] = useState(false);
  const [showRequirementModal, setShowRequirementModal] = useState(false);
  const [pendingMissingTrainings, setPendingMissingTrainings] = useState<
    string[]
  >([]);
  const [pendingMissingCertifications, setPendingMissingCertifications] =
    useState<string[]>([]);
  const [missingRequiredTrainings, setMissingRequiredTrainings] = useState<
    string[]
  >([]);
  const [missingRequiredCertifications, setMissingRequiredCertifications] =
    useState<string[]>([]);
  const [selectedRequiredTrainings, setSelectedRequiredTrainings] = useState<
    string[]
  >([]);
  const [selectedRequiredCertifications, setSelectedRequiredCertifications] =
    useState<string[]>([]);
  const [selectedTrainingMeta, setSelectedTrainingMeta] = useState<
    Record<string, { date: Date | null; description: string }>
  >({});
  const [selectedCertificationMeta, setSelectedCertificationMeta] = useState<
    Record<string, { date: Date | null; description: string }>
  >({});
  const [requirementModalSaving, setRequirementModalSaving] = useState(false);
  const [trainingLabelsById, setTrainingLabelsById] = useState<
    Record<string, string>
  >({});
  const [certificationLabelsById, setCertificationLabelsById] = useState<
    Record<string, string>
  >({});
  const [
    isMissingRequiredTrainingCertification,
    setIsMissingRequiredTrainingCertification,
  ] = useState(false);
  const navigate = useNavigate();
  const normalizeTrainingCertValue = (val: any) =>
    String(val || "")
      .trim()
      .toLowerCase();
  const mapGeneralTypeLabels = (items: any[] = []) => {
    const entries = items
      .map((item) => [
        String(item?._id || ""),
        String(item?.title || ""),
      ] as const)
      .filter(([key, val]) => key && val);
    return Object.fromEntries(entries);
  };
  const ensureTrainingCertificationLabels = async (): Promise<{
    training: Record<string, string>;
    certification: Record<string, string>;
  }> => {
    let nextTrainingLabels = trainingLabelsById;
    let nextCertificationLabels = certificationLabelsById;

    if (
      (Object.keys(nextTrainingLabels || {}).length === 0 &&
        (job?.trainings?.length || 0) > 0) ||
      (Object.keys(nextCertificationLabels || {}).length === 0 &&
        (job?.certifications?.length || 0) > 0)
    ) {
      try {
        const [trainingResponse, certificationResponse] = await Promise.all([
          getGeneralType("cleanerTrainings"),
          getGeneralType("cleanerCertifications"),
        ]);
        nextTrainingLabels = mapGeneralTypeLabels(trainingResponse?.data || []);
        nextCertificationLabels = mapGeneralTypeLabels(
          certificationResponse?.data || [],
        );
        setTrainingLabelsById(nextTrainingLabels);
        setCertificationLabelsById(nextCertificationLabels);
      } catch (e: any) {}
    }

    return {
      training: nextTrainingLabels || {},
      certification: nextCertificationLabels || {},
    };
  };

  const getMissingTrainingCertification = async (): Promise<{
    isMissing: boolean;
    missingTrainings: string[];
    missingCertifications: string[];
  }> => {
    if (
      userType !== "cleaner" ||
      !cleanerId ||
      !job?.require_certification_training
    ) {
      return {
        isMissing: false,
        missingTrainings: [],
        missingCertifications: [],
      };
    }

    const labels = await ensureTrainingCertificationLabels();
    const nextTrainingLabels = labels.training;
    const nextCertificationLabels = labels.certification;

    const requiredTrainingTitles = (
      Array.isArray(job?.trainings) ? job?.trainings : []
    )
      .map((id) => nextTrainingLabels?.[String(id)] || "")
      .map(normalizeTrainingCertValue)
      .filter(Boolean);
    const requiredCertificationTitles = (
      Array.isArray(job?.certifications) ? job?.certifications : []
    )
      .map((id) => nextCertificationLabels?.[String(id)] || "")
      .map(normalizeTrainingCertValue)
      .filter(Boolean);

    if (
      requiredTrainingTitles.length === 0 &&
      requiredCertificationTitles.length === 0
    ) {
      return {
        isMissing: false,
        missingTrainings: [],
        missingCertifications: [],
      };
    }

    try {
      const res: any = await getTraining(cleanerId, null);
      const items = Array.isArray(res?.data) ? res?.data : [];

      const cleanerTrainings = new Set<string>();
      const cleanerCertifications = new Set<string>();

      items.forEach((item: any) => {
        const documentType = normalizeTrainingCertValue(item?.documentType);
        const name = normalizeTrainingCertValue(
          item?.documentName || item?.training,
        );
        if (!name) return;

        if (documentType === "certification") {
          cleanerCertifications.add(name);
        } else {
          cleanerTrainings.add(name);
        }
      });

      const missingTrainingTitles = requiredTrainingTitles
        .filter((t) => !cleanerTrainings.has(t))
        .map((normalizedTitle) => {
          const original = (Array.isArray(job?.trainings) ? job?.trainings : [])
            .map((id) => nextTrainingLabels?.[String(id)] || "")
            .find(
              (title) => normalizeTrainingCertValue(title) === normalizedTitle,
            );
          return original || normalizedTitle;
        })
        .filter(Boolean);

      const missingCertificationTitles = requiredCertificationTitles
        .filter((c) => !cleanerCertifications.has(c))
        .map((normalizedTitle) => {
          const original = (
            Array.isArray(job?.certifications) ? job?.certifications : []
          )
            .map((id) => nextCertificationLabels?.[String(id)] || "")
            .find(
              (title) => normalizeTrainingCertValue(title) === normalizedTitle,
            );
          return original || normalizedTitle;
        })
        .filter(Boolean);

      const isMissing =
        missingTrainingTitles.length > 0 ||
        missingCertificationTitles.length > 0;
      return {
        isMissing,
        missingTrainings: missingTrainingTitles,
        missingCertifications: missingCertificationTitles,
      };
    } catch (e: any) {
      return {
        isMissing: false,
        missingTrainings: [],
        missingCertifications: [],
      };
    }
  };

  const syncMissingTrainingCertification = async () => {
    const result = await getMissingTrainingCertification();
    setMissingRequiredTrainings(result.missingTrainings);
    setMissingRequiredCertifications(result.missingCertifications);
    setIsMissingRequiredTrainingCertification(result.isMissing);
  };
  const HighlightRow = ({
    label,
    children,
  }: {
    label: React.ReactNode;
    children: React.ReactNode;
  }) => {
    return (
      <div className="py-2 lg:flex lg:gap-6">
        <div className="lg:w-64 shrink-0">
          <div className="font-bold text-base text-gray-900">{label}</div>
        </div>
        <div className="mt-1 lg:mt-0 flex-1 text-base text-gray-700 leading-relaxed">
          {children}
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (userType === "cleaner") {
      const getdetails = getUserDetails();
      setCleanerId(getdetails?.user_id);
    }
  }, []);

  const path = window.location.pathname;
  const fullLink = `https://${process.env.REACT_APP_BASE_URL}${path}`;

  const fetchJobData = async (id) => {
    setLoader("Job");
    const queryParams = new URLSearchParams();
    if (id) queryParams.append("id", id.toString());
    try {
      const result: any = await getJobs(queryParams);
      if (result?.success === true) {
        setJob(result?.data);
        setpostedDays(JobPostedAge(result?.data?.createdAt));
        setcompanyName(result?.data?.company_id?.company_name);
        setLoader("");
      }
    } catch (error) {
      setLoader("");
    }
  };
  useEffect(() => {
    const isAppliedcheck = job?.application_ids?.find(
      (item) => item?.cleaner_id === cleanerId,
    );
    if (isAppliedcheck?.job_id === id) {
      setIsApplied(true);
    }
  }, [job]);
  const fetchAddInfo = async (company_id) => {
    setLoader("AddInfo");
    try {
      const addResult = await getAdditionInfo(company_id, undefined);
      setCompanyAdditional(addResult?.data);
      setLoader("");
    } catch (e: any) {
      setLoader("");
    }
  };
  const FetchSavedJob = async (cleanerId) => {
    const result = await getSavedJobs(cleanerId);
    if (result?.success === true) {
      const data = result?.data?.job_ids?.find((item) => item?._id === id);
      if (data) {
        setIsSaved(true);
      }
      return result?.success;
    }
  };
  useEffect(() => {
    if (id) {
      fetchJobData(id);
    }
  }, [id]);
  useEffect(() => {
    if (cleanerId) {
      FetchSavedJob(cleanerId);
    }
  }, [cleanerId]);

  useEffect(() => {
    const fetchTrainingCertificationLabels = async () => {
      if (!job?.require_certification_training) return;
      if ((job?.trainings?.length || 0) === 0 && (job?.certifications?.length || 0) === 0) return;

      await ensureTrainingCertificationLabels();
    };

    fetchTrainingCertificationLabels();
  }, [
    job?.require_certification_training,
    job?.trainings,
    job?.certifications,
  ]);

  useEffect(() => {
    const checkMissingTrainingCertification = async () => {
      await syncMissingTrainingCertification();
    };

    checkMissingTrainingCertification();
  }, [
    cleanerId,
    userType,
    job?.require_certification_training,
    job?.trainings,
    job?.certifications,
    trainingLabelsById,
    certificationLabelsById,
  ]);

  useEffect(() => {
    const fetchAdd = async () => {
      await fetchAddInfo(job?.company_id._id);
    };
    if (job?.company_id) {
      fetchAdd();
    }
  }, [job?.company_id]);

  const HandleSave = async () => {
    setLoader("submit");
    if (!isAuthenticate) {
      navigate("/auth");
      return;
    }
    if (isAuthenticate && userType !== "cleaner") {
      navigate("/auth");
      return;
    }
    try {
      const data = {
        cleaner_id: cleanerId,
        job_id: id,
      };
      const result = await createFavoriteJob(data);
      if (result.success === true) {
        setLoader("");
        FetchSavedJob(cleanerId);
      }
    } catch (e: any) {
      setLoader("");
    }
  };
  const onCheckModel = () => {
    setShowModal(false);
  };

  const fetchContractor = async (company_id, cleaner_id) => {
    const queryParams = new URLSearchParams();
    queryParams.append("company_id", company_id);
    queryParams.append("cleaner_id", cleaner_id);
    const res = await getContractor(queryParams);
    if (res?.success === true) {
      return res?.data;
    }
  };

  const openRequirementModalFromWarning = async () => {
    if (!job?.require_certification_training) return;

    const missingResult = await getMissingTrainingCertification();
    if (!missingResult.isMissing) return;

    setPendingMissingTrainings(missingResult.missingTrainings);
    setPendingMissingCertifications(missingResult.missingCertifications);
    setSelectedRequiredTrainings([]);
    setSelectedRequiredCertifications([]);
    setShowRequirementModal(true);
  };

  const handleRequirementModalSave = async () => {
    setRequirementModalSaving(true);

    const trainingPayloads = (selectedRequiredTrainings || []).map((title) => {
      const meta = selectedTrainingMeta?.[title];
      return {
        cleaner_id: cleanerId,
        training: title,
        date_attended: meta?.date || new Date(),
        description: meta?.description || "",
        documentType: "training",
        documentName: title,
      };
    });

    const certificationPayloads = (selectedRequiredCertifications || []).map(
      (title) => {
        const meta = selectedCertificationMeta?.[title];
        return {
          cleaner_id: cleanerId,
          training: title,
          date_attended: meta?.date || new Date(),
          description: meta?.description || "",
          documentType: "certification",
          documentName: title,
        };
      },
    );

    const payloads = [...trainingPayloads, ...certificationPayloads];
    if (payloads.length === 0) {
      setRequirementModalSaving(false);
      return;
    }

    const results = await Promise.all(
      payloads.map((p) => createTraning(p, { silent: true })),
    );
    const allOk = results.every(Boolean);

    setRequirementModalSaving(false);
    if (allOk) {
      toast.success(
        intl.formatMessage({
          id: "JOBDETAILS.REQUIRED.TRAINING_CERTIFICATION.TOAST.SAVED",
          defaultMessage: "Saved trainings/certifications",
        }),
      );
      await syncMissingTrainingCertification();
      setPendingMissingTrainings([]);
      setPendingMissingCertifications([]);
      setShowRequirementModal(false);
    } else {
      toast.error(
        intl.formatMessage({
          id: "JOBDETAILS.REQUIRED.TRAINING_CERTIFICATION.TOAST.ERROR_SAVE",
          defaultMessage: "Some items could not be saved. Please try again.",
        }),
      );
    }
  };

  const HandleApply = async (company_id) => {
    setLoader("submit");

    if (!isAuthenticate) {
      navigate("/auth");
      return;
    }

    if (isAuthenticate && userType !== "cleaner") {
      navigate("/auth");
      return;
    }

    if (job?.require_certification_training) {
      const missingResult = await getMissingTrainingCertification();
      if (missingResult.isMissing) {
        setPendingMissingTrainings(missingResult.missingTrainings);
        setPendingMissingCertifications(missingResult.missingCertifications);
        setLoader("");
        setShowRequirementPrompt(true);
        return;
      }
    }

    const data = await fetchContractor(company_id, cleanerId);
    if (data?.some((item) => item?.cleaner_id?._id === cleanerId)) {
      toast.error("Already hired by Company");
      setLoader("");
      return;
    }

    if (!job?.require_resume) {
      await ApplyJob();
      setLoader("");
      return;
    }

    const params = { cleaner_id: cleanerId };
    const resumeData = await getFiles(params);

    if (resumeData?.success === true) {
      const filterfile = resumeData?.data?.filter(
        (item) => item.file.fieldname === "resume",
      );

      if (filterfile?.length > 0) {
        setResumes({
          oldResume: {
            originalname: filterfile[0]?.file?.originalname,
            key: filterfile[0]?.file?.key,
          },
        });
        setapplyWithOld(true);
      }
    }

    setLoader("");
    setShowModal(true);
  };

  const HandleResume = async (e: any) => {
    setLoader("submit");
    const file = e.target.files[0];
    const check = validateFile(file);
    setFileError("");
    if (check !== true) {
      setFileError(check);
      setLoader("");
      return;
    }
    try {
      const filedata = new FormData();
      filedata.append("cleaner_id", cleanerId);
      if (resumes?.oldResume?.key) {
        filedata.append("resume-job-specific", e.target.files[0]);
      } else {
        filedata.append("resume", e.target.files[0]);
      }
      const fileres = await uploadFile(filedata);
      if (fileres?.success === true) {
        setResumes((item) => ({
          ...item,
          newResume: {
            originalname: fileres?.data?.files[0]?.originalname,
            key: fileres?.data?.files[0]?.key,
          },
        }));
        setLoader("");
      }
    } catch (error) {
      setLoader("");
      console.error("Error uploading resume:", error);
    }
  };
  const ApplyJob = async () => {
    setLoader("submit");
    if (job?.require_resume === true) {
      if (!applyWithOld && !resumes?.newResume?.key) {
        setMessage("Please upload your resume");
        setLoader("");
        return;
      }
      if (applyWithOld && !resumes?.oldResume?.key) {
        setMessage("Please upload your resume");
        setLoader("");
        return;
      }
    }
    const data = {
      job_id: id,
      answers: [],
      status: "active",
      // id:"65cb2086ef25cbd6f2efd5a1",
      cleaner_id: cleanerId,
      job_resume: applyWithOld
        ? resumes?.oldResume?.key
        : resumes?.newResume?.key,
    };
    const result = await createApplication(data);
    if (result.success === true) {
      fetchJobData(id);
      setLoader("");
      setShowModal(false);

      // Check if cleaner has employment history and references
      try {
        const [employmentData, referenceData] = await Promise.all([
          getEmployment(cleanerId, undefined),
          getReference(cleanerId, undefined),
        ]);

        const hasEmployment = employmentData?.data?.length > 0;
        const hasReferences = referenceData?.data?.length > 0;

        // Show notification if either is missing
        if (!hasEmployment || !hasReferences) {
          toast.info(
            <div>
              Cleaners with references and employment history added to their
              profile are more likely to be hired by employers.{" "}
              <a
                href="/cleaner-profile-page"
                style={{
                  color: "#0078ae",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                Add yours now!
              </a>
            </div>,
            {
              autoClose: 8000,
              closeButton: true,
            }
          );
        }
      } catch (error) {
        console.error("Error checking employment/references:", error);
      }
    }
  };
  const inappropriateContent = [
    { type: "Inappropriate Content" },
    { type: "Incomplete information about job / company" },
    { type: "Fake job / Non-recruitment related job / Scam" },
    { type: "Duplicate of another job on the site" },
    { type: "Incorrect Email ID" },
    { type: "Phone number not contactable" },
    { type: "Other" },
  ];
  const HandleReportJob = async () => {
    if (!isAuthenticate && userType !== "cleaner") {
      navigate("/auth");
    }
    const payload = {
      job_id: job?.id,
      cleaner_id: cleanerId,
      reasons: reportjob,
    };
    const result = await addReportJob(payload);
    if (result?.success === true) {
      setReportJobPopup(false);
    }
  };
  const [jobTypes, setJobTypes] = useState([]);
  useEffect(() => {
    const fetchJobType = async () => {
      try {
        const res = await getJobTypeCategory();
        if (res?.success === true) {
          setJobTypes(res?.data);
        }
      } catch (e: any) {}
    };
    fetchJobType();
  }, []);
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      HandleResume({ target: { files: [file] } });
      e.dataTransfer.clearData();
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Optional: Add visual feedback
  };
  const inputRef = useRef(null);
  useEffect(() => {
    setMessage("");
  }, [applyWithOld]);

  const getLabelByValueJobDetails = (
    value: string,
    allData: any,
  ): string | undefined => {
    try {
      if (!value) return undefined;

      const normalizedValue = value.toLowerCase().replace(/\s+/g, "");

      const datas = allData.find(
        (type: any) =>
          type?.value?.toLowerCase().replace(/\s+/g, "") === normalizedValue,
      );

      return datas?.label;
    } catch (e) {
      return undefined;
    }
  };

  return (
    <>
      <Helmet>
        <title>{`${job?.job_title} Jobs`}</title>
        <meta property="og:title" content={`${job?.job_title} Jobs`} />
        <meta property="og:description" content={`${job?.job_title} Jobs`} />
      </Helmet>

      <AuthNavComponent isLoggedin={true}></AuthNavComponent>
      {loader === "submit" && <LoaderFullScreen />}
      <ContentWithSpinner loader={loader === "Job"} height="h-screen">
        <main>
          <div className="lg:container mx-auto lg:max-w-6xl lg:mt-10 mt-10 px-4 lg:px-0">
            <div className="lg:flex block">
              <div className="flex flex-col lg:w-2/3 w-full">
                <div className="card-1 p-6 mb-5 bg-white border border-gray-border rounded-xl">
                  <div className="header">
                    <h1 className="font-bold  text-lg">{job?.job_title}</h1>
                    <ContentWithLoader
                      loading={loader === "Company"}
                      content={<StringLoader />}
                    >
                      <h2 className="text-sm font-medium text-gray-800">
                        {companyName}
                      </h2>
                    </ContentWithLoader>

                    {/* <h3 className='text-xs font-normal text-gray-500'>Hiring for Leading Client</h3> */}
                  </div>

                  <div className="job-attr mt-5">
                    <div className="row-2 lg:flex block">
                      <div className="pr-8 flex items-center">
                        <FontAwesomeIcon
                          icon={faDollarSign}
                          className="text-gray-600 text-sm"
                        />

                        <span className="pl-2 text-gray-900 text-sm font-semibold">
                          {job?.show_pay_by === "Range"
                            ? `${formatNumberWithCommas((job?.min_amount || 0).toFixed(2))} - ${formatNumberWithCommas((job?.max_amount || 0).toFixed(2))}`
                            : job?.show_pay_by === "Starting amount"
                            ? formatNumberWithCommas((job?.min_amount || 0).toFixed(2))
                            : job?.show_pay_by === "Maximum amount"
                            ? formatNumberWithCommas((job?.max_amount || 0).toFixed(2))
                            : formatNumberWithCommas((job?.exact_amount || 0).toFixed(2))}
                        </span>

                        {job?.rate && (
                          <span className="pl-1 text-gray-700 text-sm font-medium">
                            <FormattedMessage
                              id={getLabelByValueJobDetails(
                                job?.rate,
                                payTypes,
                              )}
                            />
                          </span>
                        )}
                      </div>
                      {job?.job_advanced_id?.reporting_address && (
                        <div className="pr-8">
                          <FontAwesomeIcon
                            icon={faLocationDot}
                            className="text-gray-600 text-sm font-medium"
                          />
                          <span className="pl-2 text-gray-600 text-sm font-medium">
                            {
                              job?.job_advanced_id?.reporting_address
                                ?.address_line_1
                            }{" "}
                            {
                              job?.job_advanced_id?.reporting_address
                                ?.address_line_2
                            }{" "}
                            {job?.job_advanced_id?.reporting_address?.city}{" "}
                            {job?.job_advanced_id?.reporting_address?.state}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="border-t border-gray-200 my-5"></div>
                    <div className="lg:flex block justify-between items-center">
                      <div className="row-1 flex flex-col lg:flex-row lg:items-center lg:gap-8 gap-3">
                        {/* Posted */}
                        <div className="flex items-center gap-1">
                          <span className="text-gray-600">
                            <FormattedMessage
                              id="ECOMMERCE.COMMON.TEXT.POSTED"
                              defaultMessage="Posted"
                            />
                            :
                          </span>
                          <span className="text-gray-900 font-semibold">
                            <FormattedMessage
                              id="CLEANER.JOBS.TIME"
                              defaultMessage="{postedDays} Ago"
                              values={{ postedDays }}
                            />
                          </span>
                        </div>

                        {/* Openings */}
                        <div className="flex items-center gap-1">
                          <span className="text-gray-600">
                            <FormattedMessage
                              id="JOBDETAILS.OPENINGS"
                              defaultMessage="Openings"
                            />
                            :
                          </span>
                          <span className="text-gray-900 font-semibold">
                            {job?.job_advanced_id?.hire_count || 0}
                          </span>
                        </div>

                        {/* Applicants */}
                        <div className="flex items-center gap-1">
                          <span className="text-gray-600">
                            <FormattedMessage
                              id="CLEANER.JOBS.JOBAPPLICANTS"
                              defaultMessage="Job Applicants"
                            />
                            :
                          </span>
                          <span className="text-gray-900 font-semibold">
                            {job?.application_ids?.length || 0}
                          </span>
                        </div>
                      </div>

                      <div className="mt-8 lg:m-0">
                        {isApplied ? (
                          <button className="bg-[#ff39b3] text-white hover:bg-navy p-2 w-24 rounded-3xl mr-3 font-bold">
                            <FormattedMessage
                              id="APPLIEDJOBS.APPLIED"
                              defaultMessage="Applied"
                            />
                          </button>
                        ) : (
                          <button
                            onClick={() => HandleApply(job?.company_id?._id)}
                            className="bg-[#ff39b3]  text-white hover:bg-navy p-2 w-24 rounded-3xl mr-3 font-bold"
                          >
                            <FormattedMessage
                              id="JOBS.APPLYBUTTON"
                              defaultMessage="Apply"
                            />
                          </button>
                        )}

                        <button
                          onClick={HandleSave}
                          className={`border border-[#ff39b3] hover:bg-red-50 p-2 w-24 rounded-3xl font-bold ${
                            isSaved ? "text-[#ff39b3]" : "text-[#ff39b3]"
                          }`}
                        >
                          <div>
                            {" "}
                            {isSaved ? (
                              <FormattedMessage
                                id="JOBS.SAVEDBUTTON"
                                defaultMessage="Saved"
                              ></FormattedMessage>
                            ) : (
                              <FormattedMessage
                                id="JOBS.SAVEBUTTON"
                                defaultMessage="Save"
                              />
                            )}
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-2 p-6 mb-5 bg-white border border-gray-border rounded-xl">
                  <div className="flex flex-col p-6 bg-gray-50 border border-gray-border rounded-xl">
                    <h1 className="font-bold  text-base">
                      <FormattedMessage
                        id="JOBDETAILS.HIGHLIGHT.TITLE"
                        defaultMessage="Job Highlights"
                      />
                    </h1>
                    <div className="mt-2 divide-y divide-neutral-200">
                      {job?.benefits?.length > 0 && (
                        <HighlightRow
                          label={
                            <>
                              <FormattedMessage
                                id="JOBDETAILS.HIGHLIGHT.BENIFITS"
                                defaultMessage="Benefits"
                              />
                              :
                            </>
                          }
                        >
                          {job?.benefits?.map((item, index) => (
                            <span key={index}>
                              <FormattedMessage
                                id={getLabelByValue(item, benifitdata)}
                              />
                              {index !== job?.benefits?.length - 1 && (
                                <span>,&nbsp;</span>
                              )}
                            </span>
                          ))}
                        </HighlightRow>
                      )}

                      <HighlightRow
                        label={
                          <>
                            <FormattedMessage
                              id="JOBDETAILS.HIGHLIGHT.JOBTYPE"
                              defaultMessage="Job Type"
                            />
                            :
                          </>
                        }
                      >
                        {job?.job_type?.map((item, index) => (
                          <span key={index}>
                            <FormattedMessage
                              id={getLabelByValue(item, jobTypes) || "DEMO"}
                            />
                            {index < job?.job_type?.length - 1 && (
                              <span>,&nbsp;</span>
                            )}
                          </span>
                        ))}
                      </HighlightRow>

                      <HighlightRow
                        label={
                          <>
                            <FormattedMessage
                              id="JOBDETAILS.HIGHLIGHT.EMPLOYMENTTYPE"
                              defaultMessage="Employment Type"
                            />
                            :
                          </>
                        }
                      >
                        {job?.employment_type?.map((item, index) => (
                          <span key={index}>
                            <FormattedMessage
                              id={getLabelByValue(item, employment)}
                            />
                            {index !== job?.employment_type?.length - 1 && (
                              <span>,&nbsp;</span>
                            )}
                          </span>
                        ))}
                      </HighlightRow>

                      <HighlightRow
                        label={
                          <>
                            <FormattedMessage
                              id="JOBDETAILS.HIGHLIGHT.SCHEDULE"
                              defaultMessage="Schedule"
                            />
                            :
                          </>
                        }
                      >
                        {job?.schedule?.map((item, index) => (
                          <span key={index}>
                            <FormattedMessage
                              id={getLabelByValue(item, Schedule)}
                            />
                            {index !== job?.schedule?.length - 1 && (
                              <span>,&nbsp;</span>
                            )}
                          </span>
                        ))}
                      </HighlightRow>

                      <HighlightRow
                        label={
                          <>
                            <FormattedMessage
                              id="JOBDETAILS.SUPPLEMENTALPAY"
                              defaultMessage="Supplemental Pay"
                            />
                            :
                          </>
                        }
                      >
                        {job?.supplemental_pay?.map((item, index) => (
                          <span key={index}>
                            <FormattedMessage
                              id={getLabelByValue(item, supplementalpaydata)}
                            />
                            {index !== job?.supplemental_pay?.length - 1 && (
                              <span>,&nbsp;</span>
                            )}
                          </span>
                        ))}
                      </HighlightRow>

                      {typeof job?.require_certification_training ===
                        "boolean" && (
                        <div className="pt-1">
                          <HighlightRow
                            label={
                              <>
                                <FormattedMessage
                                  id="JOBDETAILS.REQUIRED.TRAINING_CERTIFICATION.TITLE"
                                  defaultMessage="Any required trainings or certifications"
                                />
                                :
                              </>
                            }
                          >
                            {job?.require_certification_training ? (
                              <FormattedMessage
                                id="JOBDETAILS.REQUIRED.TRAINING_CERTIFICATION.YES"
                                defaultMessage="Yes"
                              />
                            ) : (
                              <FormattedMessage
                                id="JOBDETAILS.REQUIRED.TRAINING_CERTIFICATION.NO"
                                defaultMessage="No"
                              />
                            )}
                          </HighlightRow>

                          {job?.require_certification_training && (
                            <>
                              <div className="mt-2 w-full rounded-lg border border-neutral-200 bg-white p-4">
                                {(job?.trainings?.length || 0) > 0 && (
                                  <div
                                    className={`${
                                      (job?.certifications?.length || 0) > 0
                                        ? "pb-4 border-b border-neutral-200"
                                        : ""
                                    }`}
                                  >
                                    <h4 className="text-base font-bold">
                                      Training
                                    </h4>
                                    <p className="mt-2">
                                      {job?.trainings
                                        ?.map(
                                          (item) =>
                                            trainingLabelsById?.[
                                              String(item)
                                            ] || String(item),
                                        )
                                        .join(", ")}
                                    </p>
                                  </div>
                                )}

                                {(job?.certifications?.length || 0) > 0 && (
                                  <div
                                    className={`${
                                      (job?.trainings?.length || 0) > 0
                                        ? "pt-4"
                                        : ""
                                    }`}
                                  >
                                    <h4 className="text-base font-bold">
                                      Certification
                                    </h4>
                                    <p className="mt-2">
                                      {job?.certifications
                                        ?.map(
                                          (item) =>
                                            certificationLabelsById?.[
                                              String(item)
                                            ] || String(item),
                                        )
                                        .join(", ")}
                                    </p>
                                  </div>
                                )}
                              </div>

                              {((job?.trainings?.length || 0) > 0 ||
                                (job?.certifications?.length || 0) > 0) &&
                                isMissingRequiredTrainingCertification && (
                                  <div className="mt-2 w-full">
                                    <TrainingCertificationRequirementWarning />
                                    <button
                                      type="button"
                                      onClick={openRequirementModalFromWarning}
                                      className="mt-2 font-bold text-sm text-[#0078ae]"
                                    >
                                      <FormattedMessage
                                        id="JOBDETAILS.REQUIRED.TRAINING_CERTIFICATION.WARNING.CTA_ADD"
                                        defaultMessage="Add required trainings/certifications"
                                      />
                                    </button>
                                  </div>
                                )}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="job-description mt-6">
                    <h1 className="font-bold  text-base">
                      <FormattedMessage
                        id="JOBDETAILS.JOBDESCRIPTION"
                        defaultMessage="Job Description"
                      />
                    </h1>
                    <div>
                      <HTMLStringRender
                        htmlContent={job?.job_description}
                      ></HTMLStringRender>
                    </div>
                  </div>

                  <div className="mt-6">
                    {/* <div><span className='font-bold  text-sm'> <FormattedMessage id="JOB.STARTDATE.TITLE" defaultMessage="Start Date" />:</span>
                                    <span className='text-sm text-gray-700 pl-1'>{DateFormat(job?.start_date)}</span>
                                </div> */}

                    {job?.job_advanced_id?.recruitment_timeline && (
                      <div>
                        <span className="font-bold  text-sm">
                          <FormattedMessage
                            id="JOB.RECRUITEMENT.TIMELINE.TITLE"
                            defaultMessage="Recruitement Timeline"
                          />
                          :
                        </span>
                        <span className="text-sm text-gray-700 pl-1">
                          {DateFormat(
                            job?.job_advanced_id?.recruitment_timeline,
                          )}
                        </span>
                      </div>
                    )}
                    {job?.job_advanced_id?.application_deadline && (
                      <div>
                        <span className="font-bold  text-sm">
                          <FormattedMessage
                            id="JOB.APPLICATION.DEADLINE.TITLE"
                            defaultMessage="Application Deadline"
                          />
                          :
                        </span>
                        <span className="text-sm text-gray-700 pl-1">
                          {DateFormat(
                            job?.job_advanced_id?.application_deadline,
                          )}
                        </span>
                      </div>
                    )}
                    {job?.rate && (
                      <div>
                        <span className="font-bold  text-sm">
                          <FormattedMessage
                            id="JOB.PAYTYPE.TITLE"
                            defaultMessage="Pay Type"
                          />
                          :
                        </span>
                        <span className="text-sm text-gray-700 pl-1">
                          {
                            <FormattedMessage
                              id={getLabelByValueJobDetails(
                                job?.rate,
                                payTypes,
                              )}
                            />
                          }{" "}
                        </span>
                      </div>
                    )}

                    {/* <h3 className='mt-5 font-bold  text-sm'><FormattedMessage 
                                    id='JOB.EDUCATION.TITLE'
                                    defaultMessage='Education'
                                    /></h3>
                                <div><span className='font-bold  text-sm'><FormattedMessage 
                                    id='JOB.EDUCATION.UG.TITLE'
                                    defaultMessage='UG'
                                    />:</span>
                                    <span className='text-sm text-gray-700 pl-1'>Any</span>
                                </div>
                                <div><span className='font-bold  text-sm'><FormattedMessage 
                                    id='JOB.EDUCATION.PG.TITLE'
                                    defaultMessage='PG'
                                    />:</span>
                                    <span className='text-sm text-gray-700 pl-1'>Any</span>
                                </div>
                                <div><span className='font-bold  text-sm'><FormattedMessage 
                                    id='JOB.EDUCATION.DOCTORATE.TITLE'
                                    defaultMessage='Doctorate'
                                    />:</span>
                                    <span className='text-sm text-gray-700 pl-1'>
                                        <FormattedMessage 
                                    id='JOB.EDUCATION.DOCTORATE.NOT.REQUIRED'
                                    defaultMessage='Doctorate Not Required'
                                    /></span>
                                </div> */}

                    {/* <h3 className='mt-5 font-bold  text-sm'> <FormattedMessage 
                                    id='JOB.KEY.SKILLS'
                                    defaultMessage='Key Skills'
                                    /></h3>
                                <div className='flex mt-2'>
                                    <div className='border py-1 px-3 rounded-3xl text-sm font-semibold text-gray-600 mr-1'>Azure</div>
                                    <div className='border py-1 px-3 rounded-3xl text-sm font-semibold text-gray-600 mr-1'>GCP</div>
                                    <div className='border py-1 px-3 rounded-3xl text-sm font-semibold text-gray-600 mr-1'>AWS</div>
                                    <div className='border py-1 px-3 rounded-3xl text-sm font-semibold text-gray-600 mr-1'>ES5</div>
                                </div> */}
                    <div className="w-full flex justify-between border-t-2 items-center mt-4">
                      <SocialShare title={job?.job_title} fullLink={fullLink} />
                      <p
                        onClick={() => setReportJobPopup(true)}
                        className="text-sm font-bold  text-[#0078ae] cursor-pointer"
                      >
                        <FormattedMessage
                          id="JOB.REPORT.TITLE"
                          defaultMessage="Report this Job"
                        />
                      </p>{" "}
                    </div>
                  </div>
                </div>

                <div className="card-2 p-6 mb-5 bg-white border border-gray-border rounded-xl">
                  <h1 className="font-bold  text-base">
                    <FormattedMessage
                      id="JOB.ABOUT.COMPANY.TITLE"
                      defaultMessage={"About Company"}
                    />
                  </h1>
                  <ContentWithLoader
                    loading={loader === "AddInfo"}
                    content={<StringLoader />}
                  >
                    <div>{companyAdditional?.about_company}</div>
                  </ContentWithLoader>

                  <h3 className="mt-5 font-bold  text-sm">
                    <FormattedMessage
                      id="JOB.COMPANY.INFO.TITLE"
                      defaultMessage={"Company Info"}
                    />
                  </h3>
                  <div>
                    <span className="font-bold  text-sm">
                      <FormattedMessage
                        id="JOB.COMPANY.ADDRESS.TITLE"
                        defaultMessage={"Address"}
                      />
                      :
                    </span>
                    <span className="text-sm text-gray-700 pl-1">
                      {job?.job_advanced_id?.reporting_address?.address_line_1}{" "}
                      {job?.job_advanced_id?.reporting_address?.address_line_2}{" "}
                      {job?.job_advanced_id?.reporting_address?.city}{" "}
                      {job?.job_advanced_id?.reporting_address?.state}
                    </span>
                  </div>
                  {job?.company_id?.mobile_number && (
                    <div>
                      <span className="font-bold text-sm">
                        Company Phone Number:
                      </span>
                      <span className="text-sm text-gray-700 pl-1">
                        {job.company_id.mobile_number}
                      </span>
                    </div>
                  )}
                  <div className="flex space-x-2 my-4">
                    {companyAdditional?.social_link_fb && (
                      <Link
                        className="rounded-lg py-0.5 px-2 transition-ease-out duration-25 bg-[#3b5998] hover-[#2d4373] border-[#3b5998] 
                                     hover:bg-[#2d4373] hover:border-[#2d4373] active:bg-[#2d4373] active:border-[#2d4373]"
                        to={companyAdditional?.social_link_fb}
                      >
                        <div
                          aria-hidden="true"
                          className="inline-block fill-white stroke-none"
                        >
                          <svg
                            className="h-4 w-4 m-0 align-middle inline-block"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"></path>
                          </svg>
                        </div>
                      </Link>
                    )}
                    {companyAdditional?.social_link_twitter && (
                      <Link
                        className="rounded-lg transition-ease-out duration-25 bg-[#0288D1] hover:bg-[#2795e9] hover:border-[#2795e9] active:bg-[#2795e9] active:border-[#2795e9]"
                        to={companyAdditional?.social_link_twitter}
                      >
                        <div
                          aria-hidden="true"
                          className="inline-block fill-white stroke-none"
                        >
                          <svg
                            className="h-8 w-8 m-0 align-middle inline-block"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 48 48"
                          >
                            <path
                              fill="#0288D1"
                              d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                            />
                            <path
                              fill="#FFF"
                              d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                            />
                          </svg>
                        </div>
                      </Link>
                    )}
                  </div>
                </div>
              </div>

              {job && isAuthenticate && userType === "cleaner" && (
                <InterestedJobs job={job} />
              )}
            </div>
          </div>
        </main>
        <ModelWrapperWithButton
          showModal={showModal}
          onCheckModel={onCheckModel}
          savetext={"Continue"}
          Save={ApplyJob}
        >
          {message && (
            <p className="mt-1 text-red-400 md:text-sm sm:text-[.65rem]">
              {message}
            </p>
          )}
          {resumes?.oldResume?.originalname && (
            <div>
              <p className="">Continue With</p>
              <div className="flex space-x-3">
                <Checkbox
                  label={resumes?.oldResume?.originalname}
                  checked={applyWithOld === true}
                  value={applyWithOld}
                  onChange={(e: any) => setapplyWithOld(!applyWithOld)}
                  id={"resumeshow"}
                ></Checkbox>
              </div>
            </div>
          )}
          {!applyWithOld && (
            <>
              <div className=" mt-5">Upload Resume</div>
              <p className="text-red-800">{fileerror && fileerror}</p>
              <div className="flex items-center justify-center w-full mt-2">
                <label
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  htmlFor="dropzone-file"
                  className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                >
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg
                      className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 16"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                      />
                    </svg>
                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span className="font-semibold">Click to upload</span> or
                      drag and drop
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      Supported Formats: doc, docx, rtf, pdf, upto 2 MB
                    </p>
                  </div>
                  <input
                    ref={inputRef}
                    onChange={HandleResume}
                    id="dropzone-file"
                    type="file"
                    className="hidden"
                  />
                </label>
              </div>
              {resumes?.newResume?.originalname && (
                <div className="flex items-center justify-between  w-full my-4 px-5">
                  <p className="">{resumes?.newResume?.originalname} </p>
                </div>
              )}
            </>
          )}
        </ModelWrapperWithButton>
        {reportJobPopup && (
          <ModelWrapper
            showModal={reportJobPopup}
            rounded="rounded-[10px]"
            background="bg-[#00000099]"
            position="fixed"
            opacity="opacity-100"
            topPosition="top-[10%]"
            rightPosition="inset-0"
            width="w-[50%] mx-auto"
          >
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative  my-6 max-w-3xl w-4/5 h-4/5">
                {/*content*/}
                <div className="border-0 bg-white p-6 rounded-[20px] shadow-sm shadow-slate-300  relative flex flex-col w-full  outline-none focus:outline-none">
                  {/*header*/}
                  <div className="flex items-start justify-between p-5 rounded-t">
                    <h1 className="font-bold text-3xl mb-4 ">
                      Report this job
                    </h1>
                    <button className="p-1 ml-auto bg-transparent border-0 text-black opacity-1 float-right text-3xl leading-none font-semibold outline-none focus:outline-none">
                      <span
                        onClick={() => setReportJobPopup(false)}
                        className="bg-transparent text-black opacity-1 h-6 w-6 text-2xl block outline-none focus:outline-none"
                      >
                        ×
                      </span>
                    </button>
                  </div>
                  {/* body  */}
                  {inappropriateContent?.map((item) => (
                    <Checkbox
                      label={item?.type}
                      id={item?.type}
                      value={item?.type}
                      checked={reportjob?.includes(item?.type)}
                      onChange={(e) =>
                        CheckBoxHandle(e, reportjob, setReportJob)
                      }
                    ></Checkbox>
                  ))}
                  <div className="flex justify-end">
                    <button
                      onClick={HandleReportJob}
                      className="bg-[#ff39b3] font-bold text-white hover:bg-navy p-2 w-24 rounded-3xl mr-3"
                    >
                      <FormattedMessage id="AUTH.GENERAL.SUBMIT_BUTTON"></FormattedMessage>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ModelWrapper>
        )}
        <RequiredTrainingCertificationModal
          open={showRequirementModal}
          loading={requirementModalSaving}
          pendingTrainings={pendingMissingTrainings}
          pendingCertifications={pendingMissingCertifications}
          selectedTrainings={selectedRequiredTrainings}
          selectedCertifications={selectedRequiredCertifications}
          trainingMeta={selectedTrainingMeta}
          certificationMeta={selectedCertificationMeta}
          setSelectedTrainings={setSelectedRequiredTrainings}
          setSelectedCertifications={setSelectedRequiredCertifications}
          setTrainingMeta={setSelectedTrainingMeta}
          setCertificationMeta={setSelectedCertificationMeta}
          onClose={() => {
            if (requirementModalSaving) return;
            setShowRequirementModal(false);
          }}
          onSave={handleRequirementModalSave}
        />
        <ConfirmModal
          open={showRequirementPrompt}
          title={
            <FormattedMessage
              id="JOBDETAILS.REQUIRED.TRAINING_CERTIFICATION.CONFIRM.TITLE"
              defaultMessage="Required Trainings/ Certifications Missing"
            />
          }
          message={
            <FormattedMessage
              id="JOBDETAILS.REQUIRED.TRAINING_CERTIFICATION.CONFIRM.MESSAGE"
              defaultMessage="If you already have the required training or certifications, would you like to add them now?"
            />
          }
          onConfirm={() => {
            setShowRequirementPrompt(false);
            setSelectedRequiredTrainings([]);
            setSelectedRequiredCertifications([]);
            setSelectedTrainingMeta({});
            setSelectedCertificationMeta({});
            setShowRequirementModal(true);
          }}
          onCancel={() => setShowRequirementPrompt(false)}
          disabled={requirementModalSaving}
        />
      </ContentWithSpinner>
      <Footer />
    </>
  );
}
